export enum Role {
    ADMINISTRATOR = 'ADMINISTRATOR',
    CUSTOMER = 'CUSTOMER',
    COMPANY = 'COMPANY',
}